// extracted by mini-css-extract-plugin
module.exports = {"Button":"BackButton_Button__2LF5H","Text":"BackButton_Text__1KIQm","Arrow":"BackButton_Arrow__W71ZK"};